module.exports = __webpack_public_path__ + "build/img/6.1464cbb0.png";